// @generated by protoc-gen-es v1.6.0 with parameter "target=js"
// @generated from file dymensionxyz/dymension/lockup/lock.proto (package dymensionxyz.dymension.lockup, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Duration, proto3, Timestamp } from "@bufbuild/protobuf";
import { Coin } from "./coin_pb.js";

/**
 * LockQueryType defines the type of the lock query that can
 * either be by duration or start time of the lock.
 *
 * @generated from enum dymensionxyz.dymension.lockup.LockQueryType
 */
export const LockQueryType = proto3.makeEnum(
  "dymensionxyz.dymension.lockup.LockQueryType",
  [
    {no: 0, name: "ByDuration"},
    {no: 1, name: "ByTime"},
  ],
);

/**
 * PeriodLock is a single lock unit by period defined by the x/lockup module.
 * It's a record of a locked coin at a specific time. It stores owner, duration,
 * unlock time and the number of coins locked. A state of a period lock is
 * created upon lock creation, and deleted once the lock has been matured after
 * the `duration` has passed since unbonding started.
 *
 * @generated from message dymensionxyz.dymension.lockup.PeriodLock
 */
export const PeriodLock = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.PeriodLock",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "duration", kind: "message", T: Duration },
    { no: 4, name: "end_time", kind: "message", T: Timestamp },
    { no: 5, name: "coins", kind: "message", T: Coin, repeated: true },
  ],
);

/**
 * QueryCondition is a struct used for querying locks upon different conditions.
 * Duration field and timestamp fields could be optional, depending on the
 * LockQueryType.
 *
 * @generated from message dymensionxyz.dymension.lockup.QueryCondition
 */
export const QueryCondition = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.QueryCondition",
  () => [
    { no: 1, name: "lock_query_type", kind: "enum", T: proto3.getEnumType(LockQueryType) },
    { no: 2, name: "denom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "duration", kind: "message", T: Duration },
    { no: 4, name: "timestamp", kind: "message", T: Timestamp },
  ],
);

